<template>
    <div class="quantityCounter">
        <input
            class="formInput"
            type="number"
            :name="name"
            v-model.number="quantity"
            :min="min"
            :max="max"
            ref="input"
        />

        <button
            class="quantityBtn quantityBtn--remove"
            type="button"
            @click="quantity--"
            :disabled="quantity <= min"
        >
            <span class="visually-hidden">-</span></button>
        <button
            class="quantityBtn quantityBtn--add"
            type="button"
            @click="quantity++"
            :disabled="quantity >= max"
        >
            <span class="visually-hidden">+</span>
        </button>
    </div>
</template>



<script>
export default {

    /* Settings
    --------------------------------------------------------- */

    name: 'QuantityCounter',


    props: {
        name: { type: String, default: 'quantity' },
        min: { type: Number, default: 1 },
        max: { type: Number },
        startQuantity: { type: Number, required: true },
        disableEnterKeypress: { type: Boolean, default: false },
    },


    data() {
        return {
            quantity: this.$props.startQuantity,
        }
    },

    mounted() {
        // disable submit on press enter in field
        if (this.disableEnterKeypress) {
            const input = this.$el.querySelector('input[type="number"]')
            input.addEventListener('keypress', (e) => {
                if (e.keyCode === 13) {
                    e.preventDefault()
                }
            })
        }
    },




    /* Data Handling
    --------------------------------------------------------- */

    computed: {
        //
    },


    watch: {
        quantity(q) {
            const { min, max } = this.$props

            if (q < min) this.$data.quantity = min
            if (q > max) this.$data.quantity = max

            this.$emit('input', { target: this.$refs.input })
        },
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {
        //
    },

}

</script>
